import src from '../assets/nextlevelgolf.png';
import { imageLogo } from './imageLogo';

/**
 * Next Level Golf — teal-green square badge on transparency.
 * Drop the actual logo PNG at ../assets/nextlevelgolf.png (1024×1024).
 */
export const NextLevelGolfLogo = imageLogo({
  src,
  width: 1024,
  height: 1024,
  alt: 'Next Level Golf',
});
